<template>
  <v-expansion-panel>
    <v-expansion-panel-header class="overline"> Banner-bild </v-expansion-panel-header>
    <v-expansion-panel-content>
      <ImageComponent v-model="image" />
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import ImageComponent from '@/components/shared/Image'

export default {
  name: 'ReportBannerImage',
  props: {
    article_image_id: { type: String  },
  },
  components: {
    ImageComponent,
  },
  computed: {
    image: {
      get() {
        return !Number.isNaN(this.article_image_id)
          ? `${process.env.VUE_APP_IMAGE_BACKEND}/870/${this.article_image_id}.jpg`
          : this.article_image_id
      },
      set(val) {
        this.$emit('update', { article_image_id: val.toString() })
      },
    },
  },
}
</script>

<style lang="less" scoped></style>
